import React from 'react';
import ConnectWithUsForm from './ConnectUs';

const officeMapQuery = 'G 405 Reliable Shreejee Empire, Next to Vimal height, Nalasopara West 401203';
const officeMapSearchUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(officeMapQuery)}`;
const officeMapEmbedUrl = `https://maps.google.com/maps?q=${encodeURIComponent(officeMapQuery)}&t=&z=16&ie=UTF8&iwloc=&output=embed`;

const ContactUs = () => {
    return (
        <div className="contact-us-container">
            <div className="contact-us-header">
                <h1 className="contact-us-title">Get in Touch with Us</h1>
                <p className="contact-us-description">
                    Contact Subhash Bhambid for professional pest management across Mumbai and suburbs.
                </p>
            </div>

            <ConnectWithUsForm />

            <div className="contact-us-map">
                <h2>Office Location</h2>
                <p className="contact-us-map-address">
                    G 405 Reliable Shreejee Empire, Next to Vimal height, Nalasopara West. Pin code- 401203
                </p>
                <div className="map-container">
                    <iframe
                        title="Spiracle Pest Worlds Office Location"
                        src={officeMapEmbedUrl}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
                <a
                    className="contact-us-map-link"
                    href={officeMapSearchUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Open in Google Maps
                </a>
            </div>

            <div className="contact-us-map">
                <h2>Service Areas</h2>
                <ul className="contact-detail">
                    <li>Mumbai</li>
                    <li>Thane</li>
                    <li>Navi Mumbai</li>
                    <li>Palghar</li>
                </ul>
            </div>
        </div>
    );
};

export default ContactUs;
